import ParticipantList from "../../slices/participant/ParticipantList";
import BuddyList from "../../slices/participant/BuddyList";

const participantReducer = {
    participantList: ParticipantList,
    buddyList: BuddyList,
};

export default participantReducer;